import { useNavigate } from "react-router-dom";

import MultipleChoiceQuestion from "../../../components/Questions/MultipleChoiceQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import { CustomerSupportVulnerabilityCircumstanceMiscellaneousInput } from "../../../generated/customer/schema.graphql";

type MiscQuestionRecord = Record<
  keyof CustomerSupportVulnerabilityCircumstanceMiscellaneousInput,
  string
>;

type MiscQuestion = Omit<MiscQuestionRecord, "developmentalCondition">;

export const miscQuestions: MiscQuestion = {
  hasCarelineInstalledOrReliantOnCommsServices:
    "Has a dependency on carelines or health and wellbeing alarms",
  unableToCommunicateInEnglish: "Unable to communicate in English",
  dementiaOrCognitiveImpairment:
    "Dementia or cognitive impairment (e.g. Alzheimer's, dementia)",
  physicalImpairment:
    "Physical impairment (e.g. osteoporosis, muscular dystrophy, multiple sclerosis)",
  mentalHealthIssue:
    "Diagnosed mental health issue (e.g. clinical depression, schizophrenia)",
  speechImpairment: "Speech impairment",
  recentlyRecoveringFromAHospitalVisit:
    "Recovering from a hospital stay in the last 30 days",
  restrictiveHandMovement: "Restrictive hand movement",
  unableToAnswerTheDoor: "Unable to answer the door",
  additionalPresencePreferred: "Additional presence preferred",
  poorSenseOfSmellOrTaste: "Poor sense of smell, taste",
  temporaryYoungAdultHouseholderUnder18:
    "Temporary young adult householder under 18",
  waterDependent: "Water dependent",
  medicineRefrigeration: "Medicine refrigeration",
  medicallyDependantOnWarmHome: "Has a medical dependency on a warm home",
  neurologicalDiseases:
    "Neurological disease (e.g. Parkinson's Disease, Huntington's Disease, cerebral palsy)",
  nutritionalIssues: "Nutritional Issues (e.g. Malnutrition)",
  learningDifficultiesOrDisablities:
    "Adult householder with Learning Disabilities and Difficulties",
};

const Miscellaneous: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (newAnswers: Record<string, boolean>) => {
    setAnswers({
      ...answers,
      miscellaneous: newAnswers,
      ...(!newAnswers.recentlyRecoveringFromAHospitalVisit ||
      !newAnswers.temporaryYoungAdultHouseholderUnder18
        ? {
            psr: undefined,
          }
        : {}),
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.ChronicIllness}`);
  };

  return (
    <MultipleChoiceQuestion
      onChange={onChange}
      options={miscQuestions}
      values={answers.miscellaneous}
      onContinue={onContinue}
      step={questionContent.miscellaneous.step}
      title={questionContent.miscellaneous.title}
      subTitle={questionContent.miscellaneous.subTitle}
      whyWeWantTexts={questionContent.miscellaneous.whyWeWantTextsCustomer}
    />
  );
};

export default Miscellaneous;
